import _default2 from"ramda/src/keys";import _default from"ramda/src/reduce";var defineProperty=function(e,r,n){return r in e?Object.defineProperty(e,r,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[r]=n,e},upperFirst=function(e){return e.charAt(0).toUpperCase()+e.substr(1)},longhand=function(e,r){return _default(function(n,t){var a=""+e+upperFirst(t),u=r[t];return Object.assign({},n,defineProperty({},a,u))},{},_default2(r))};export default longhand;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@team-griffin/css-longhand/dist/es/css-longhand.production.js
// module id = 1288
// module chunks = 0